// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavigationMenuItem__item___s8Ttd {
	align-items: center;
	background: rgba(4, 10, 13, 0.46);
	border: 1px solid rgba(104, 113, 109, 0.34);
	border-radius: 999px;
	box-sizing: border-box;
	display: flex;
	height: 34px;
	justify-content: center;
	margin: 0;
	position: relative;
	transition: background 120ms ease, border-color 120ms ease, box-shadow 120ms ease, transform 120ms ease;
	width: 34px;
}

.NavigationMenuItem__item___s8Ttd:hover,
.NavigationMenuItem__item___s8Ttd:focus-within {
	background: rgba(16, 29, 34, 0.78);
	border-color: rgba(143, 155, 149, 0.58);
	box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.18), 0 6px 14px rgba(0, 0, 0, 0.28);
	transform: translateX(1px);
}

.NavigationMenuItem__active___fvkqL {
	background: rgba(16, 29, 34, 0.78);
	border-color: rgba(226, 181, 85, 0.68);
	box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.18), 0 6px 14px rgba(0, 0, 0, 0.28);
	transform: translateX(1px);
}

.NavigationMenuItem__active___fvkqL .NavigationMenuItem__icon___f7cSJ,
.NavigationMenuItem__active___fvkqL .NavigationMenuItem__icon___f7cSJ *,
.NavigationMenuItem__active___fvkqL .NavigationMenuItem__icon___f7cSJ *::before {
	color: rgb(235, 240, 235) !important;
}

.NavigationMenuItem__active___fvkqL .NavigationMenuItem__icon___f7cSJ {
	filter: drop-shadow(0 0 2px rgba(255, 215, 96, 0.9)) drop-shadow(0 0 5px rgba(255, 196, 56, 0.65));
	text-shadow: 0 0 7px gold !important;
}

.NavigationMenuItem__item___s8Ttd,
.NavigationMenuItem__item___s8Ttd * {
	text-shadow: none !important;
}

.NavigationMenuItem__icon___f7cSJ {
	margin: 0;
	font-size: 1em;
	position: relative;
	left: 0;
	top: 0;
	display: block;
	transform: none;
}

.NavigationMenuItem__badgeDefault___ZGn_W {
	color: silver;
	position: relative;
	top: -6px;
	background: darkred;
	padding: 0px 4px;
	font-size: 11px;
	border-radius: 7px;
	font-weight: bold;
	left: 25px;
	transform: none;
	filter: sepia(0.5);
	opacity: 0.8;
}

.NavigationMenuItem__inactive___HB6uQ {
	opacity: 0.5;
}

.NavigationMenuItem__hidden___ZBQt9 {
	display: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `NavigationMenuItem__item___s8Ttd`,
	"active": `NavigationMenuItem__active___fvkqL`,
	"icon": `NavigationMenuItem__icon___f7cSJ`,
	"badgeDefault": `NavigationMenuItem__badgeDefault___ZGn_W`,
	"inactive": `NavigationMenuItem__inactive___HB6uQ`,
	"hidden": `NavigationMenuItem__hidden___ZBQt9`
};
module.exports = ___CSS_LOADER_EXPORT___;
